import { loadJSSVG } from "../../general/functions";

const generateStaging = function (staging) {

    let curLabel, curString;

    switch (staging) {
        case 'NEW':
            curLabel = ' label-light-success ';
            curString = 'NEW'
            break;
        case 'ACTIVE':
            curLabel = ' label-light-primary ';
            curString = 'ACTIVE'
            break;
        case 'INACTIVE':
            curLabel = ' label-light-danger ';
            curString = 'INACTIVE'
            break;
        case 'FINISHED':
            curLabel = ' label-light-info ';
            curString = 'FINISHED'
            break;
        case 'CLOSED':
            curLabel = ' label-light-warning ';
            curString = 'CLOSED'
            break;
        case 'CANCELED':
            curLabel = ' label-light-danger ';
            curString = 'CANCEL'
            break;
        case 'CANCEL':
            curLabel = ' label-light-danger ';
            curString = 'CANCEL'
            break;
        case 'COMPLETE':
            curLabel = ' label-light-warning ';
            curString = 'COMPLETE'
            break;
        case 'DONE':
            curLabel = ' label-light-dark ';
            curString = 'DONE'
            break;
        case 'OPEN':
            curLabel = ' label-light-dark ';
            curString = 'OPEN'
            break;

        /** Status untuk APPLICATION */
        case "CREATED":
            curLabel = " label-light-success border-success ";
            curString = "Created";
            break;

        case "WITHDRAW":
            curLabel = " label-light-danger border-danger ";
            curString = "Withdraw";
            break;

        case "PAID DEPOSIT":
            curLabel = " label-light-danger border-warning text-warning ";
            curString = "Paid ICAN Deposit";
            break;

        case "APPLIED":
            curLabel = " label-light-secondary border-secondary text-dark";
            curString = "Applied";
            break;

        case "PAID APPLICATION":
        case "CLOSING APPLICATION":
            curLabel = " label-light-warning border-warning text-warning";
            curString = "Paid Application Fee";
            break;

        case "PAID TUITION":
        case "CLOSING TUITION":
            curLabel = " label-light-warning border-warning text-warning";
            curString = "Paid Tuition Fee";
            break;

        case "CONDITIONAL-OFFER":
            curLabel = " label-light-info border-info ";
            curString = "Conditional Offer";
            break;

        case "FULL-OFFER":
            curLabel = " label-light-primary border-primary ";
            curString = "Full Offer";
            break;

        case "VISA PROCESS":
        case "VISA APPLIED":
            curLabel = " label-light-info border-info ";
            curString = "Visa Process";
            break;

        case "APPROVED":
        case "VISA APPROVE":
            curLabel = " label-light-info border-info ";
            curString = "Visa Approved";
            break;

        case "REJECTED":
            curLabel = " label-light-info border-info ";
            curString = "Visa Rejected";
            break;

        case "WITHDRAW":
            curLabel = " label-light-info border-info ";
            curString = "Withdrawn";
            break;

        default:
            curLabel = " label-light-danger border-danger ";
            curString = "Not Created";
            break;

    }

    return {
        label: curLabel,
        text: curString
    };

}

const formatPrograms = function (program) {

    let curProgram = '';
    let formattedProgram = '';

    // Split program
    if (program != null) {

        if (program.indexOf('-') !== false) {

            let progList = program.split(';');

            for (let i = 0; i < progList.length; i++) {
                curProgram += progList[i].split('-')[0] + ', ';
            }

        } else {
            curProgram = program;
        }

        formattedProgram = curProgram.trim().slice(0, -1) + '';

    } else {
        formattedProgram = '-';
    }


    return formattedProgram;
}

const formatSchool = function (school) {

    let schoolName = '';

    if (school.indexOf('-')) {
        let finalString = school.split('-')

        schoolName = finalString[0]
    } else {
        schoolName = finalString
    }

    return schoolName

}

const generateMobileNumber = function (number) {

    let formattedNumber = '-';

    if (number == '' || number == null || number == '-') {
        return formattedNumber;
    } else {

        // Hapus semua simbol
        let tmpNumber = number.replace(/[-+]/g, '');

        if (tmpNumber.substring(0, 1) == '8') {
            tmpNumber = '62' + tmpNumber;
        } else if (tmpNumber.substring(0, 2) == '08') {
            tmpNumber = '62' + tmpNumber.substring(1);
        }

        formattedNumber = `${tmpNumber}
        <a href="https://api.whatsapp.com/send?phone=${tmpNumber}" target="_blank">
          <span class="font-weight-bolder">${loadJSSVG['whatsapp-sm']}</span>
        </a>`;

    }

    return formattedNumber;
}

export {
    generateStaging,
    generateMobileNumber,
    formatPrograms,
    formatSchool
}